import Button from "../../components/ui/Button";
import Modal from "../../components/ui/Modal";
import React from "react";
import "./PaymentDetailsModal.css";
import { PurchaseOrder } from "../../data/mockPurchaseOrders";
import completedIcon from "../../assets/images/completedicon.png";

interface PaymentDetailsModalProps {
  order: PurchaseOrder;
  onClose: () => void;
  onConfirm: () => void;
}

const PaymentDetailsModal: React.FC<PaymentDetailsModalProps> = ({
  order,
  onClose,
  onConfirm,
}) => {
  const totalCost = order.cartItems.reduce(
    (acc, item) => acc + (item.totalCost || 0),
    0,
  );

  return (
    <Modal title={<>Payment Details</>} onClose={onClose} size="medium">
<div className="modal-content legacy-modal-content" onClick={(e) => e.stopPropagation()}>

        <div className="modal-body payment-details-body">
          <div className="payment-info-row">
            <span>Total Cost of Order</span>
            <span className="payment-amount">
              ₦{totalCost.toLocaleString()}
            </span>
          </div>
          <div className="payment-info-row">
            <span>Payment Status</span>
            <div className="payment-status-chip">
              <img src={completedIcon} alt="Completed" />
              <span>Completed</span>
            </div>
          </div>
          <div className="payment-info-row">
            <span>Paid on</span>
            <span>
              {new Date(order.paymentDetails!.paymentDate).toLocaleDateString(
                "en-GB",
                { day: "numeric", month: "long", year: "numeric" },
              )}
            </span>
          </div>
        </div>
        <div className="modal-footer">
          <Button type="button" variant="primary" className="confirm-btn" onClick={onConfirm}>
            Approve
          </Button>
        </div>
      </div>
</Modal>
  );
};

export default PaymentDetailsModal;
